<template>
  <div class="modal active" v-scroll-lock="fn_IS_MOBILE() ? false : active">
    <div class="modal-overlay"></div>

    <form
      :class="[appointmentFull && 'appointment-full']"
      class="modal-container appointment-simple"
      @submit.prevent="saveEvent()"
    >
      <header class="modal-header appointment-simple__header">
        <a
          class="btn btn-clear float-right appointment-simple__close"
          aria-label="close"
          @click="close"
        >
        </a>
      </header>

      <article
        :class="(didHappen || isAppAppointment) && 'appointment-simple--disabled'"
        class="modal-body appointment-simple__body"
      >
        <!-- Nome do paciente -->
        <div class="appointment-simple__main-row">
          <dr-autocomplete
            :ref="'autocomplete_patientName'"
            :key="'autocomplete_patientName'"
            :endpoint="`${fn_GET_PARENT_ROUTE($route)}/doctor_office/${office.id}/special_patient`"
            :new-filter="true"
            :format="'{$name}'"
            :fields="['filterAndLike[sp.name]']"
            :return-format="'object'"
            :disable-local="true"
            :class="[
              `${String(formData.schedulingType.value).toLowerCase()}`,
              ($v.formData.specialPatient.name.$error) && 'has-error',
              (isAppointment && isToday && !didHappen && appointmentFull && canStart) && 'appointment-simple__patient--start'
            ]"
            class="appointment-simple__patient autocomplete-patient"
            placeholder="Nome do Paciente"
            @change="patientObject = $event"
            @input="patientName = $event"
          />

          <button
            v-if="isAppointment && isToday && !didHappen && appointmentFull && canStart"
            class="btn btn-blue appointment-simple__start-appointment"
            @click.prevent="startAppointment()"
          >
            <span>
              Iniciar consulta
              <i class="icon icon-arrow-right" />
            </span>
          </button>
        </div>

        <!-- Tipo de agendamento -->
        <ul class="appointment-simple__type">
          <li class="appointment-simple__type-drconecta">
            <div
              v-if="isAppAppointment"
              class="appointment-simple__type-drconecta-badge"
            >
              <img src="/static/img/favicon.png" alt="Consulta Dr. Conecta">
            </div>
          </li>

          <li
            v-for="type in schedulingType"
            :key="`appointment-type__${type.name}`"
            class="appointment-simple__type-name"
          >
            <input
              v-model="formData.schedulingType.value"
              :value="type.value"
              :id="`appointment-simple__type--${type.name}`"
              name="appointment-simple__type"
              class="appointment-simple__type-radio"
              type="radio"
            >

            <label
              :for="`appointment-simple__type--${type.name}`"
              :class="[
                'appointment-simple__type-label',
                `appointment-simple__type-label--${type.name}`
              ]"
            >
              {{ type.name }}
            </label>
          </li>

          <!-- Serviço médico: versão completa -->
          <li
            v-if="(formData['schedulingType'].value === 'EXAME_PROCEDIMENTO') && appointmentFull"
            class="m-0"
          >
            <transition name="fade">
              <dr-appointment-medical-service
                v-if="formData['schedulingType'].value === 'EXAME_PROCEDIMENTO' && appointmentFull"
                :selected-medical-service.sync="formData['doctorOfficeMedicalService'].value"
                :has-error.sync="$v.formData.doctorOfficeMedicalService.$invalid"
                :office-id.sync="office.id"
                @on-select="setDoctorOfficeMedicalService"
              />
            </transition>
          </li>
        </ul>

        <!-- Serviço médico: versão simplificada -->
        <transition name="fade">
          <dr-appointment-medical-service
            v-if="formData['schedulingType'].value === 'EXAME_PROCEDIMENTO' && !appointmentFull"
            :selected-medical-service.sync="formData['doctorOfficeMedicalService'].value"
            :has-error.sync="$v.formData.doctorOfficeMedicalService.$invalid"
            :office-id.sync="office.id"
            @on-select="setDoctorOfficeMedicalService"
          />
        </transition>

        <!-- Horário de agendamento -->
        <div class="appointment-simple__row">
          <dr-icon
            :key="'clock-icon'"
            ref="clock-icon"
            name="clock"
            color="gray"
            class="appointment-simple__row-icon"
          />

          <div class="appointment-simple__row-wrapper">
            <div
              v-click-outside="() => showCalendar = false"
              :class="showCalendar && 'appointment-simple__field--focused'"
              class="appointment-simple__field appointment-simple__date"
            >
              <span @click="showCalendar = !showCalendar">
                {{ $moment(appointmentStartDate).format('DD MMM YYYY') }}
              </span>

              <div class="appointment-simple__date-picker">
                <dr-calendar
                  v-show="showCalendar"
                  v-model="appointmentStartDate"
                  @change="showCalendar = false"
                />
              </div>
            </div>

            <!-- Appointment Start -->
            <div class="appointment-simple__time">
              <span class="px-2">das</span>

              <div class="appointment-simple__field">
                <!-- Appointment Start Hours -->
                <div
                  v-click-outside="() => showStartHour = false"
                  @click.prevent="showStartHour = !showStartHour"
                >
                  <span :class="showStartHour && 'appointment-simple__field--nobg'">
                    {{ String(appointmentStartHour).padStart(2, '0') }}
                  </span>

                  <dr-appointment-time-picker
                    v-if="showStartHour"
                    ref="appointmentStartHour"
                    :selected.sync="appointmentStartHour"
                    :fn="(v) => appointmentStartHour = v"
                    type="hour"
                  />
                </div>

                <span>h</span>

                <!-- Appointment Start Minutes -->
                <div
                  v-click-outside="() => showStartMin = false"
                  @click.prevent="showStartMin = !showStartMin"
                >
                  <span :class="showStartMin && 'appointment-simple__field--nobg'">
                    {{ String(appointmentStartMin).padStart(2, '0') }}
                  </span>

                  <dr-appointment-time-picker
                    v-if="showStartMin"
                    ref="appointmentStartMin"
                    :selected.sync="appointmentStartMin"
                    :fn="(v) => appointmentStartMin = v"
                    type="minute"
                  />
                </div>
              </div>

              <span class="px-2">às</span>

              <!-- Appointment End -->
              <div class="appointment-simple__field">
                <!-- Appointment End Hours -->
                <div
                  v-click-outside="() => showEndHour = false"
                  @click.prevent="showEndHour = !showEndHour"
                >
                  <span :class="showEndHour && 'appointment-simple__field--nobg'">
                    {{ String(appointmentEndHour).padStart(2, '0') }}
                  </span>

                  <dr-appointment-time-picker
                    v-if="showEndHour"
                    ref="appointmentEndHour"
                    :from.sync="appointmentEndHourFrom"
                    :selected="appointmentEndHour"
                    :fn="(v) => appointmentEndHour = v"
                    type="hour"
                  />
                </div>

                <span>h</span>

                <!-- Appointment End Minutes -->
                <div
                  v-click-outside="() => showEndMin = false"
                  @click.prevent="showEndMin = !showEndMin"
                >
                  <span :class="showEndMin && 'appointment-simple__field--nobg'">
                    {{ String(appointmentEndMin).padStart(2, '0') }}
                  </span>

                  <dr-appointment-time-picker
                    v-if="showEndMin"
                    ref="appointmentEndMin"
                    :selected="appointmentEndMin"
                    :fn="(v) => appointmentEndMin = v"
                    type="minute"
                  />
                </div>
              </div>

              <div
                v-if="appointmentFull"
                v-click-outside="() => showCalendarEnd = false"
                :class="showCalendarEnd && 'appointment-simple__field--focused'"
                class="appointment-simple__field appointment-simple__date"
              >
                <span @click="showCalendarEnd = !showCalendarEnd">
                  {{ $moment(appointmentEndDate).format('DD MMM YYYY') }}
                </span>

                <div class="appointment-simple__date-picker">
                  <dr-calendar
                    v-show="showCalendarEnd"
                    v-model="appointmentEndDate"
                    @change="showCalendarEnd = false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Telefone + E-mail + Data de nascimento -->
        <div class="appointment-simple__row">
          <div class="appointment-simple__row-wrapper">
            <!-- Telefone -->
            <div
              :class="appointmentFull && 'appointment-full__col'"
              class="appointment-simple__telephone flex w-full overflow-hidden"
            >
              <dr-icon
                :key="'telephone-icon'"
                ref="telephone-icon"
                name="telephone"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['ddi']"
                :value.sync="formData.specialPatient['ddi'].value"
                :id="'ddi'"
                :ref="'ddi'"
                :key="'appointment-simple-ddi'"
                :class="[(formData.specialPatient['ddi'].value) && 'has-value']"
                class="appointment-simple__select appointment-simple__select--auto"
                prefix="appointment-simple"
                style="max-width: 3rem; margin-bottom: 0; margin-right: 5px;"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['telephone']"
                :value.sync="formData.specialPatient['telephone'].value"
                :id="'telephone'"
                :ref="'telephone'"
                :key="'appointment-simple-telephone'"
                :class="[
                  (formData.specialPatient['telephone'].value) && 'has-value',
                  $v.formData.specialPatient.telephone.$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
                style="width: calc(100% - 4rem);"
              />
            </div>

            <!-- Endereço de e-mail -->
            <div
              v-if="appointmentFull"
              :class="appointmentFull && 'appointment-full__col'"
              class="appointment-simple__email"
            >
              <dr-icon
                :key="'email-icon'"
                ref="email-icon"
                name="email"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['email']"
                :value.sync="formData.specialPatient['email'].value"
                :id="'email'"
                :ref="'email'"
                :key="'appointment-simple-email'"
                :class="[
                  (formData.specialPatient['email'].value) && 'has-value',
                  $v.formData.specialPatient.email.$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <!-- Data de nascimento -->
            <div
              v-if="appointmentFull"
              :class="appointmentFull && 'appointment-full__col'"
              class="appointment-simple__birthday"
            >
              <dr-icon
                :key="'birthday-icon'"
                ref="birthday-icon"
                name="birthday"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['birthdate']"
                :value.sync="formData.specialPatient['birthdate'].value"
                :id="'birthdate'"
                :ref="'birthdate'"
                :key="'appointment-simple-birthdate'"
                :class="[
                  (formData.specialPatient['birthdate'].value) && 'has-value',
                  $v.formData.specialPatient.birthdate.$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>
          </div>
        </div>

        <!-- CPF + RG + Cartão SUS -->
        <div
          v-if="appointmentFull"
          class="appointment-simple__row"
        >
          <div class="appointment-simple__row-wrapper">
            <!-- CPF -->
            <div class="appointment-full__col appointment-simple__email">
              <dr-icon
                :key="'cpf-icon'"
                ref="cpf-icon"
                name="cpf"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['cpf']"
                :value.sync="formData.specialPatient['cpf'].value"
                :id="'cpf'"
                :ref="'cpf'"
                :key="'appointment-simple-cpf'"
                :class="[
                  (formData.specialPatient['cpf'].value) && 'has-value',
                  $v.formData.specialPatient.cpf.$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <!-- RG -->
            <div class="appointment-full__col appointment-simple__email">
              <dr-icon
                :key="'rg-icon'"
                ref="rg-icon"
                name="rg"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['rg']"
                :value.sync="formData.specialPatient['rg'].value"
                :id="'rg'"
                :ref="'rg'"
                :key="'appointment-simple-rg'"
                :class="[
                  (formData.specialPatient['rg'].value) && 'has-value',
                  $v.formData.specialPatient['rg'].$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <!-- Cartão SUS -->
            <div class="appointment-full__col appointment-simple__email">
              <dr-icon
                :key="'sus-icon'"
                ref="sus-icon"
                name="sus"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['nationalHealthCard']"
                :value.sync="formData.specialPatient['nationalHealthCard'].value"
                :id="'nationalHealthCard'"
                :ref="'nationalHealthCard'"
                :key="'appointment-simple-nationalHealthCard'"
                :class="(formData.specialPatient['nationalHealthCard'].value) && 'has-value'"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>
          </div>
        </div>

        <!-- Endereço -->
        <div
          v-show="appointmentFull"
          class="appointment-simple__row"
        >
          <dr-icon
            :key="'map-icon'"
            ref="map-icon"
            name="map"
            fill="gray"
            class="appointment-simple__row-icon"
          />

          <div class="appointment-simple__row-wrapper appointment-full__wrapper appointment-full__address">
            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['cep']"
              :value.sync="formData.address['cep'].value"
              @focus="formData.address['cep'].value = null"
              :id="'cep'"
              :ref="'cep'"
              :key="'appointment-simple-cep'"
              :class="(formData.address['cep'].value) && 'has-value'"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['street']"
              :value.sync="formData.address['street'].value"
              :id="'street'"
              :ref="'street'"
              :key="'appointment-simple-street'"
              :class="[
                (formData.address['street'].value) && 'has-value',
                $v.formData.address.street.$invalid && 'has-error'
              ]"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['number']"
              :value.sync="formData.address['number'].value"
              :id="'number'"
              :ref="'number'"
              :key="'appointment-simple-number'"
              :class="[
                (formData.address['number'].value) && 'has-value',
                $v.formData.address.number.$invalid && 'has-error'
              ]"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['complement']"
              :value.sync="formData.address['complement'].value"
              :id="'complement'"
              :ref="'complement'"
              :key="'appointment-simple-complement'"
              :class="(formData.address['complement'].value) && 'has-value'"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['district']"
              :value.sync="formData.address['district'].value"
              :id="'district'"
              :ref="'district'"
              :key="'appointment-simple-district'"
              :class="[
                (formData.address['district'].value) && 'has-value',
                $v.formData.address.district.$invalid && 'has-error'
              ]"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['city']"
              :value.sync="formData.address['city'].value"
              :id="'city'"
              :ref="'city'"
              :key="'appointment-simple-city'"
              :class="(formData.address['city'].value) && 'has-value'"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />

            <dr-field
              :form.sync="formData"
              :field.sync="formData.address['uf']"
              :value.sync="formData.address['uf'].value"
              :id="'uf'"
              :ref="'uf'"
              :key="'appointment-simple-uf'"
              :class="(formData.address['uf'].value) && 'has-value'"
              class="appointment-simple__input appointment-full__address-field"
              prefix="appointment-simple"
            />
          </div>
        </div>

        <!-- Gênero + Indicação -->
        <div
          v-if="appointmentFull"
          class="appointment-simple__row"
        >
          <!-- Gênero -->
          <div class="appointment-simple__row-wrapper appointment-full__info">
            <div class="appointment-full__info-field">
              <dr-icon
                :key="'person-icon'"
                ref="person-icon"
                name="person"
                fill="gray"
                class="appointment-simple__row-icon sm"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData.specialPatient['gender']"
                :value.sync="formData.specialPatient['gender'].value"
                :id="'gender'"
                :ref="'gender'"
                :key="'appointment-simple-gender'"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>
          </div>
        </div>

        <!-- Modalidade de atendimento -->
        <div class="appointment-simple__row">
          <dr-icon
            :key="'category-icon'"
            ref="category-icon"
            name="category"
            fill="gray"
            class="appointment-simple__row-icon"
          />

          <div class="appointment-simple__row-wrapper">
            <div
              v-if="showHealthplaceInfo"
              class="appointment-simple__cate"
            >
              <dr-field
                :field="healthPlaceInfoMsg"
                :value="healthPlaceInfoMsg.value"
                :id="'appointmentType'"
                :ref="'appointmentType'"
                :key="'appointment-simple-appointmentType'"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <div
              v-if="!showHealthplaceInfo"
              class="appointment-simple__category"
            >
              <dr-field
                :form.sync="formData"
                :field.sync="formData['appointmentType']"
                :value.sync="formData['appointmentType'].value"
                :id="'appointmentType'"
                :ref="'appointmentType'"
                :key="'appointment-simple-appointmentType'"
                class="appointment-simple__input"
                prefix="appointment-simple"
                @click="(event) => handleModalityClick(event)"
              />
            </div>
          </div>
        </div>

        <!-- Plano de Saúde -->
        <transition name="fade">
          <dr-appointment-health-insurance
            v-show="formData['appointmentType'].value === 'CONVENIO'"
            :ref="'appointmentHealthInsurance'"
            :health-insurance-plans.sync="patientHealtInsurancePlans"
            :error-fields.sync="healthPlanErrorFields"
            @on-choose-plan="setHealthPlan"
          />
        </transition>

        <!-- Preço da consulta -->
        <div class="appointment-simple__row">
          <dr-icon
            :key="'dollar-icon'"
            ref="dollar-icon"
            name="dollar"
            fill="gray"
            class="appointment-simple__row-icon"
          />

          <div
            :class="appointmentFull && 'appointment-full__payment'"
            class="appointment-simple__row-wrapper"
          >
            <div
              :class="appointmentFull && 'appointment-full__payment-col'"
              class="appointment-simple__value"
            >
              <dr-field
                :form.sync="formData"
                :field.sync="formData['value']"
                :value.sync="formData['value'].value"
                :id="'value'"
                :ref="'value'"
                :key="'appointment-simple-value'"
                :class="[
                  (formData['value'].value.converted) && 'has-value',
                  $v.formData.value.$error && 'has-error'
                ]"
                @focused="isValueEdited = true"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <!-- Método de pagamento -->
            <div
              v-if="appointmentFull"
              class="appointment-full__payment-col"
            >
              <dr-icon
                :key="'payment-icon'"
                ref="payment-icon"
                name="payment"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData['paymentMethod']"
                :value.sync="formData['paymentMethod'].value"
                :id="'paymentMethod'"
                :ref="'paymentMethod'"
                :key="'appointment-simple-paymentMethod'"
                :class="(formData['paymentMethod'].value > 0) && 'has-value'"
                class="appointment-simple__select appointment-simple__select--auto"
                prefix="appointment-simple"
              />
            </div>

            <!-- Data de recebimento -->
            <div
              v-if="appointmentFull"
              class="appointment-full__payment-col"
            >
              <dr-icon
                :key="'calendar-icon'"
                ref="calendar-icon"
                name="calendar"
                fill="gray"
                class="appointment-simple__row-icon"
              />

              <dr-field
                :form.sync="formData"
                :field.sync="formData['receiptDate']"
                :value.sync="formData['receiptDate'].value"
                :id="'receiptDate'"
                :ref="'receiptDate'"
                :key="'appointment-simple-receiptDate'"
                :class="[
                  (formData['receiptDate'].value) && 'has-value',
                  $v.formData.receiptDate.$invalid && 'has-error'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>

            <!-- Status do pagamento -->
            <div
              v-if="appointmentFull"
              class="appointment-full__payment-col"
            >
              <dr-switch
                v-model="formData['paymentStatus'].value"
                :key="'appointment-simple-paymentStatus'"
                label-checked="Pago"
                label-unchecked="Não pago"
              />
            </div>
          </div>
        </div>

        <!-- Indicação -->
        <div class="appointment-simple__row" v-if="appointmentFull">
            <dr-icon
              :key="'referral-icon'"
              ref="referral-icon"
              name="referral"
              fill="gray"
              class="appointment-simple__row-icon"
            />

            <div class="appointment-simple__row-wrapper">
              <div class="appointment-full__info-field">
                <dr-field
                  :id="'referral'"
                  :ref="'referral'"
                  :key="'appointment-simple-referral'"
                  :form.sync="formData"
                  :field.sync="formData['referral']"
                  :value="formData['referral'].value"
                  :class="(formData['referral'].value) && 'has-value'"
                  class="appointment-simple__input"
                  prefix="appointment-simple"
                  @typed="fn_LOG($event)"
                />
            </div>
          </div>
        </div>

        <!-- Observação -->
        <div class="appointment-simple__row">
          <dr-icon
            :key="'note-icon'"
            ref="note-icon"
            name="note"
            fill="gray"
            class="appointment-simple__row-icon"
            style="align-self: flex-start; margin-top: 0.45rem;"
          />

          <div class="appointment-simple__row-wrapper">
            <div class="appointment-simple__note">
              <dr-field
                :form.sync="formData"
                :field.sync="formData['note']"
                :value.sync="formData['note'].value"
                :id="'note'"
                :ref="'note'"
                :key="'appointment-simple-note'"
                :class="[
                  `${String(formData.schedulingType.value).toLowerCase()}`,
                  formData['note'].value && 'has-value'
                ]"
                class="appointment-simple__input"
                prefix="appointment-simple"
              />
            </div>
          </div>
        </div>

        <transition name="fade">
          <div
            v-if="!isAppAppointment && formData.schedulingType.value !== 'RETORNO'"
            class="appointment-simple__row"
          >
            <div
              :class="appIntegration && !appIntegration['is_active'] && 'clickable'"
              class="appointment-simple__row-wrapper"
              @click="showAppIntegrationAlert()"
            >
              <dr-switch
                v-model="formData['hasMedicalConsultationReturn'].value"
                :key="'appointment-simple-medicalConsultationReturn'"
                id="appointmentSimpleMedicalConsultationReturn"
                :disabled="appIntegration && !appIntegration['is_active']"
                label-checked="Retorno automático"
                label-unchecked="Retorno automático"
              />

              <span
                :data-tooltip="medicalConsultationReturnInfo"
                class="tooltip tooltip-top page-info"
              >
                <dr-icon
                  class="v-icon"
                  color="silver"
                  name="info"
                />
              </span>
            </div>
          </div>
        </transition>
      </article>

      <footer class="modal-footer appointment-simple__footer">
        <button
          v-if="isAppointment && !didHappen && appointmentFull && !isPast"
          class="btn btn-red appointment-simple__cancel"
          @click.prevent="cancelAppointment()"
        >
          <span>Cancelar consulta</span>
        </button>

        <button
          v-if="isAppointment && !didHappen && appointmentFull && isPast"
          class="btn btn-red appointment-simple__cancel"
          @click.prevent="notifyAbsence()"
        >
          <span>Informar ausência</span>
        </button>

        <div
          v-if="!didHappen"
          class="appointment-simple__simple"
        >
          <button
            v-if="!appointmentFull"
            class="appointment-simple__more"
            @click="appointmentFull = true"
          >
            Mais informações
          </button>

          <dr-submit
            v-if="!isAppAppointment"
            class="appointment-simple__submit"
            text="Salvar"
          />
        </div>

        <div
          v-if="didHappen"
          class="appointment-simple__happened"
        >
          <span>
            Consulta realizada em {{ $moment(appointment['appointment_start']).format('DD/MM/YYYY [às] HH:mm') }}.
          </span>
        </div>

        <div
          v-if="/telemedicina/gi.test(formData.appointmentType.value) && !didHappen && !isAppointment"
          :class="`${String(formData.schedulingType.value).toLowerCase()}`"
          class="appointment-simple__telemedicine-msg"
        >
          Ao salvar esse agendamento, o paciente receberá o link para a consulta por e-mail e SMS.
        </div>

        <transition name="fade">
          <div
            v-if="patientLastAppointment && appointmentFull"
            class="appointment-simple__consultation-msg"
          >
            Última consulta
            <span>({{ patientLastAppointment.type | REMOVE_UNDERSCORE | TO_CAPITALIZE }})</span>
            em {{ $moment(patientLastAppointment['appointment_start']).format('DD/MM/YYYY [às] HH:mm') }}.
          </div>
        </transition>
      </footer>
    </form>
  </div>
</template>

<script>
import { schedulingType, formData, validations } from '@/data/formData/appointmentSimple'
import { DrCalendar } from 'cm2tech-vue-calendar'
import DrAppointmentHealthInsurance from '@/components/modals/agenda/appointmentHealthInsurance'
import DrAppointmentMedicalService from '@/components/modals/agenda/appointmentMedicalService'
import DrAppointmentTimePicker from '@/components/modals/agenda/appointmentTimePicker'
import DrAutocomplete from '@/components/form/autocomplete'
import DrSubmit from '@/components/form/submit'
import DrSwitch from '@/components/form/switch'
import DrField from '@/components/form/field'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrAppointmentSimple',

  components: {
    DrAppointmentHealthInsurance,
    DrAppointmentMedicalService,
    DrAppointmentTimePicker,
    DrAutocomplete,
    DrCalendar,
    DrSubmit,
    DrSwitch,
    DrField
  },

  props: {
    currentDate: {
      type: String,
      required: true,
      default: () => ''
    },

    active: {
      type: Boolean,
      required: false,
      default: () => true
    },

    appointment: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  validations: {
    formData: validations
  },

  data () {
    const initialHour = (Math.ceil(this.$moment(this.currentDate).minutes() / 5) * 5) > 55
      ? this.$moment(this.currentDate).hours() + 1
      : this.$moment(this.currentDate).hours()

    const initialMin = (Math.ceil(this.$moment(this.currentDate).minutes() / 5) * 5) > 55
      ? 0
      : Math.ceil(this.$moment(this.currentDate).minutes() / 5) * 5

    return {
      schedulingType,
      formData,
      now: this.$moment(this.currentDate),
      showCalendar: false,
      showCalendarEnd: false,
      showStartHour: false,
      showStartMin: false,
      showEndHour: false,
      showEndMin: false,
      isHealthPlanSaved: false,
      specialPatientId: null,
      appointmentStarted: false,
      appointmentStartHour: initialHour,
      appointmentStartMin: initialMin,
      appointmentEndHour: initialHour,
      appointmentEndMin: initialMin,
      patientName: null,
      patientObject: null,
      appointmentFull: false,
      appointmentStatus: null,
      patientLastAppointment: null,
      officeHealthPlansPrices: null,
      shouldValidateCep: true,
      appointmentStartDate: null,
      appointmentEndDate: null,
      appointmentEndHourFrom: 0,
      hasAppointmentFinalDate: false,
      isValueEdited: false,
      medicalConsultationReturnInfo: String(
        'Ao deixar essa opção ativada, você permite\n' +
        'que o paciente agende o retorno para essa\n' +
        'consulta, num período máximo de 30 dias\n' +
        'a partir do atendimento. O paciente receberá\n' +
        'um e-mail com as instruções para o agendamento,\n' +
        'de forma automatizada, gerando conforto,\n' +
        'rapidez e comodidade para médico e paciente.\n'
      ),
      showHealthplaceInfo: false,
      healthPlaceInfoMsg: {
        name: 'healthPlaceInfoMsg',
        radios: [{ label: '', value: 0 }],
        type: 'radio',
        value: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice',
      appIntegration: 'getAppIntegration',
      isCertificateExpired: 'getNewCertifierCredentialRequired',
      plan: 'getPlan'
    }),

    shouldBlockStartAppointment () {
      if (this.isAppointment) {
        return /^(?=.*healthplace)(?=.*telemedicin(e|a)).+/gim.test(this.appointment.type) &&
          this.isCertificateExpired
      }

      return false
    },

    appointmentInterval () {
      const hours = this.$moment(this.office['appointment_interval']).hours()
      const minutes = this.$moment(this.office['appointment_interval']).minutes()

      return (hours * 60) + minutes
    },

    patientHealtInsurancePlans () {
      if (
        this.patientObject &&
        !this.isAppAppointment &&
        'special_patient_health_insurances' in this.patientObject &&
        this.patientObject['special_patient_health_insurances'].length > 0
      ) {
        return this.patientObject['special_patient_health_insurances']
      }

      return null
    },

    healthPlanErrorFields () {
      const fields = []
      const healthPlan = {
        healthInsurance: this.$v.formData.specialPatientHealthInsurance.healthInsurance.$invalid,
        walletNumber: this.$v.formData.specialPatientHealthInsurance.walletNumber.$invalid,
        walletValidity: this.$v.formData.specialPatientHealthInsurance.walletValidity.$invalid
      }

      for (const key in healthPlan) {
        if (healthPlan[key]) {
          fields.push(key)
        }
      }

      return fields
    },

    isAppointment () {
      return !!this.formData.id.value
    },

    isAppAppointment () {
      if (this.isAppointment) {
        return /(drconecta|healthplace)/gi.test(this.appointment.type)
      }

      return false
    },

    isPast () {
      const startMoment = this.$moment(this.formData.appointmentStart.value).add(1, 'h')

      return (this.$moment().isAfter(startMoment, 'm'))
    },

    isToday () {
      const startMoment = this.$moment(this.formData.appointmentStart.value)

      return (this.$moment().isSame(startMoment, 'd'))
    },

    canStart () {
      if (
        this.appointment &&
        this.appointment.id &&
        (
          /aberto/gi.test(this.appointment.status) ||
          /aguardando confirmação pelo paciente/gi.test(this.appointment.status)
        )
      ) {
        return true
      }

      return false
    },

    didHappen () {
      return (this.appointmentStatus === 'REALIZADO')
    },

    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    }
  },

  watch: {
    appointmentStartDate: {
      deep: false,
      immediate: false,
      handler (v) {
        const now = this.$moment()
        const then = this.$moment(v)

        if (then.isBefore(now, 'day') && this.hasAppointmentFinalDate) {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Por favor, escolha uma data no futuro',
            size: 'md',
            active: true
          })

          this.appointmentStartDate = this.$moment().toISOString()
        }
      }
    },

    appointmentEndDate: {
      deep: false,
      immediate: false,
      handler (v) {
        const start = this.$moment(this.appointmentStartDate)
        const end = this.$moment(v)

        if (end.isBefore(start, 'day')) {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'A data final não pode ser menor que a data inicial',
            size: 'md',
            active: true
          })

          this.appointmentEndDate = this.appointmentStartDate
        }

        this.setAppointmentEnd()
      }
    },

    appointmentInterval: {
      deep: true,
      immediate: true,
      handler () {
        this.setAppointmentEnd()
      }
    },

    appointmentStartHour: {
      deep: true,
      immediate: true,
      handler () {
        this.setAppointmentEnd()
        this.setAppointmentDate()
      }
    },

    appointmentStartMin: {
      deep: true,
      immediate: true,
      handler () {
        this.setAppointmentEnd()
        this.setAppointmentDate()
      }
    },

    appointmentEndHour: {
      deep: true,
      immediate: true,
      handler () {
        this.setAppointmentDate()
      }
    },

    appointmentEndMin: {
      deep: true,
      immediate: true,
      handler () {
        this.setAppointmentDate()
      }
    },

    now: {
      deep: true,
      immediate: false,
      handler () {
        this.setAppointmentDate()
      }
    },

    patientObject: {
      deep: true,
      immediate: false,
      handler (obj, oldObj) {
        this.shouldValidateCep = false

        if (obj) {
          this.specialPatientId = obj['id']
          this.formData.specialPatient.telephone.value = obj['contact_phone']
            ? `(${obj['contact_phone'].slice(0, 2)}) ${obj['contact_phone'].slice(2, 7)}-${obj['contact_phone'].slice(7)}`
            : null
          this.formData.specialPatient.email.value = obj['email']
          this.formData.specialPatient.cpf.value = this.$filters.TO_CPF(obj['cpf'])
          this.formData.specialPatient.rg.value = obj['rg']
          this.formData.specialPatient.gender.value = obj['gender']
          this.formData.specialPatient.nationalHealthCard.value = obj['national_health_card']
          this.formData.specialPatient.birthdate.value = obj['date_of_birth'] && this.$moment(obj['date_of_birth']).format('DD/MM/YYYY')
          this.formData.specialPatient.name.value = obj['name']
          this.formData.specialPatient.ddi.value = this.formData.specialPatient.ddi.options
            .find((option) => option.code === obj['ddi_contact_phone'])
            .id

          if ('address' in obj && obj['address']) {
            this.formData.address.cep.value = this.$filters.TO_CEP(obj['address'].cep)
            this.formData.address.city.value = obj['address'].city.name
            this.formData.address.complement.value = obj['address'].complement
            this.formData.address.district.value = obj['address'].district
            this.formData.address.latitude.value = obj['address'].latitude
            this.formData.address.longitude.value = obj['address'].longitude
            this.formData.address.number.value = obj['address'].number
            this.formData.address.street.value = obj['address'].street
            this.formData.address.uf.value = obj['address'].uf.name
          }

          this.getLastAppointment()
        } else {
          this.specialPatientId = null
          this.formData.specialPatient.ddi.value = 'br'
          this.formData.specialPatient.telephone.value = null
          this.formData.specialPatient.email.value = null
          this.formData.specialPatient.cpf.value = null
          this.formData.specialPatient.rg.value = null
          this.formData.specialPatient.gender.value = null
          this.formData.specialPatient.nationalHealthCard.value = null
          this.formData.specialPatient.birthdate.value = null
          this.formData.specialPatient.name.value = null
          this.patientName = null

          this.formData.address.cep.value = null
          this.formData.address.city.value = null
          this.formData.address.uf.value = null
          this.formData.address.district.value = null
          this.formData.address.street.value = null
          this.formData.address.number.value = null
          this.formData.address.complement.value = null
          this.formData.address.latitude.value = null
          this.formData.address.longitude.value = null
        }

        this.$nextTick(() => {
          this.shouldValidateCep = true
        })
      }
    },

    patientName: {
      deep: false,
      immediate: false,
      handler (v) {
        if (v) {
          this.formData.specialPatient.name.value = v
        } else {
          this.formData.specialPatient.name.value = null
        }
      }
    },

    'formData.address.cep.value': {
      deep: false,
      immediate: false,
      handler (v, prev) {
        const regex = /([\d]){5}-([\d]){3}/g // RegEx CEP
        if (regex.test(v)) {
          this.searchAddress(v)
        }
        if ((v || '').length < (prev || '').length) {
          for (let addressField in this.formData.address) {
            if (addressField !== 'cep') {
              this.formData.address[addressField].value = null
            }
          }
        }
      }
    },

    'formData.appointmentType.value': {
      deep: false,
      immediate: true,
      handler (v) {
        if (this.plan.isPro && /telemedicina/gi.test(v)) {
          this.$nextTick(() => {
            this.formData.appointmentType.value = 'PARTICULAR'
          })

          this.$store.dispatch('togglePlanModal', { showModal: true })
          return
        }

        if (/particular_telemedicina/gi.test(v)) {
          this.appointmentFull = true
        }

        if (!this.appointment && !this.isValueEdited) {
          if (
            !/consulta/gi.test(this.formData.schedulingType.value) &&
            !/particular_telemedicina/gi.test(v)
          ) {
            return this.setModalPriceValue('0')
          }

          if (!/^particular$/gi.test(v) && !/particular_telemedicina/gi.test(v)) {
            return this.setModalPriceValue('0')
          }

          if (this.office['private_specialty_price']) {
            this.setModalPriceValue(this.office['private_specialty_price'])
          }
        }
      }
    },

    'formData.schedulingType.value': {
      deep: false,
      immediate: true,
      handler (v) {
        if (!this.appointment) {
          if (
            !/consulta/gi.test(this.formData.schedulingType.value) &&
            !/particular_telemedicina/gi.test(this.formData.appointmentType.value)
          ) {
            return this.setModalPriceValue('0')
          }

          if (
            !/^particular$/gi.test(this.formData.appointmentType.value) &&
            !/particular_telemedicina/gi.test(this.formData.appointmentType.value)
          ) {
            return this.setModalPriceValue('0')
          }

          if (this.office['private_specialty_price']) {
            this.setModalPriceValue(this.office['private_specialty_price'])
          }
        }

        if (v === 'RETORNO') {
          this.formData.hasMedicalConsultationReturn.value = false
        }
      }
    },

    'formData.specialPatientHealthInsurance.healthInsurance.value': {
      deep: false,
      immediate: false,
      handler (id, oldId) {
        if (this.officeHealthPlansPrices && id && id !== oldId) {
          const plan = this.officeHealthPlansPrices
            .find(plan => plan['health_insurance'].id === id)

          if (plan) {
            this.setModalPriceValue(plan.value)
          }
        }
      }
    },

    'formData.hasMedicalConsultationReturn.value': {
      deep: false,
      immediate: false,
      handler (v) {
        if (v) {
          this.appointmentFull = true
        }
      }
    },

    'formData.specialPatient.ddi.value': {
      deep: false,
      immediate: false,
      handler (next, before) {
        if (next !== before) {
          const { mask } = this.formData.specialPatient.ddi.options
            .find((option) => option.id === next)

          this.formData.specialPatient.telephone.mask = next === 'br'
            ? ['(##) ####-####', '(##) #####-####']
            : [mask]
        }
      }
    }
  },

  created () {
    this.formData.paymentMethod.options
      .find((o) => o.value === 'HEALTHPLACE PRÉ PAGO')
      .hidden = true

    this.formData.paymentMethod.options
      .find((o) => o.value === 'HEALTHPLACE PRÉ PAGO VOUCHER')
      .hidden = true

    this.formData.appointmentType.value = 'PARTICULAR'
    this.formData.schedulingType.value = 'CONSULTA'
    this.formData.receiptDate.value = this.now.format('DD/MM/YYYY')
    this.localActive = this.active

    if (this.appointment) {
      this.appointmentStartHour = parseInt(this.$moment(this.appointment['appointment_start']).format('HH'))
      this.appointmentStartMin = parseInt(this.$moment(this.appointment['appointment_start']).format('mm'))

      this.appointmentStartDate = this.$moment(this.appointment['appointment_start']).toISOString()
      this.appointmentEndDate = this.$moment(this.appointment['appointment_finish']).toISOString()
    } else {
      this.appointmentStartDate = this.$moment(this.currentDate).toISOString()
      this.appointmentEndDate = this.$moment(this.currentDate).toISOString()
    }

    this.formData.specialPatient.ddi.value = 'br'
  },

  mounted () {
    if ('id' in this.office && this.office.id && !this.isAppAppointment) {
      this.getOfficeHealthPlansPrices()
        .then((res) => (this.officeHealthPlansPrices = res.data.data))
        .catch(err => console.log(err))
    }

    this.autoResizeTextarea()

    if (this.appointment) {
      this.loadAppointmentData(this.appointment, this.formData)

      this.$nextTick(() => {
        this.appointmentEndHour = parseInt(this.$moment(this.appointment['appointment_finish']).format('HH'))
        this.appointmentEndMin = parseInt(this.$moment(this.appointment['appointment_finish']).format('mm'))
      })
    }

    this.$nextTick(() => {
      this.hasAppointmentFinalDate = true
    })
  },

  destroyed () {
    this.destroyApiObject(this.formData)
    this.formData = null
  },

  methods: {
    setModalPriceValue (value) {
      if (!value) return
      const price = {
        raw: value,
        converted: this.$options.filters.TO_BRL(value)
      }
      this.$set(this.formData.value, 'value', price)
    },

    getOfficeHealthPlansPrices () {
      const url = `${
        this.prefix
      }/doctor_office/${
        this.office.id
      }/doctor_office_health_insurance?itensPerPage=100`

      return this.$http.get(url, this.$store.getters.getAuthHeader)
    },

    getLastAppointment () {
      if (!this.patientLastAppointment && !this.isAppAppointment) {
        const url = `/${this.fn_GET_PARENT_ROUTE(this.$route)}/special_patient/${this.specialPatientId}`

        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            const { appointments } = res.data
            this.patientLastAppointment = appointments.reverse()
              .find(appointment => /realizado/gi.test(appointment.status))
          })
          .catch(err => console.log('err\n', err))
      }
    },

    saveEvent () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        const id = this.formData.id.value
          ? `/${this.formData.id.value}`
          : ''

        const officeId = this.formData.id.value
          ? this.appointment['doctor_office'].id
          : this.office.id

        const url = `/${
          this.fn_GET_PARENT_ROUTE(this.$route)
        }/doctor_office/${officeId}/agenda${id}`

        const data = { agenda: this.buildApiObject() }
        const method = (this.formData.id.value) ? 'put' : 'post'
        const headers = this.$store.getters.getAuthHeader.headers

        this.fn_SHOW_PROGRESS()
        this.$http({ url, method, data, headers })
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Agenda atualizada com sucesso.',
              size: 'md',
              active: true
            })
            setTimeout(() => {
              this.$store.dispatch('setModalAlert', {
                active: false
              })
            }, 2000)
            this.close()
          })
          .catch((err) => {
            this.handleError(err)
          })
          .finally(() => {
            this.fn_HIDE_PROGRESS()
            EventBus.$emit('agenda-reload', { officeId: this.office.id })
          })
      }
    },

    buildApiObject () {
      // Appointment
      // const appointmentStart = this.formData.appointmentStart.value
      // const appointmentFinish = this.formData.appointmentFinish.value

      const appointmentStart = this.$moment(this.appointmentStartDate)
        .startOf('day')
        .set({
          'hour': this.appointmentStartHour,
          'minute': this.appointmentStartMin,
          'second': 0
        })
        .format('YYYY-MM-DD HH:mm:ss')

      const appointmentFinish = this.$moment(this.appointmentEndDate)
        .startOf('day')
        .set({
          'hour': this.appointmentEndHour,
          'minute': this.appointmentEndMin,
          'second': 0
        })
        .format('YYYY-MM-DD HH:mm:ss')

      const medicalConsultationType = this.formData.schedulingType.value
      const type = this.formData.appointmentType.value

      // Special patient
      const name = (this.patientObject && 'name' in this.patientObject)
        ? this.patientObject.name
        : this.patientName
      const dateOfBirth = (this.formData.specialPatient.birthdate.value)
        ? this.$moment(
          this.formData.specialPatient.birthdate.value,
          'DD/MM/YYYY',
          true).format('YYYY-MM-DD')
        : null
      const contactPhone = (this.formData.specialPatient.telephone.value)
        ? this.fn_NUMBERS_ONLY(this.formData.specialPatient.telephone.value)
        : null

      const ddiContactPhone = contactPhone
        ? this.formData.specialPatient.ddi.options
          .find((option) => option.id === this.formData.specialPatient.ddi.value)
          .code
        : ''

      const cpf = (this.formData.specialPatient.cpf.value)
        ? this.fn_NUMBERS_ONLY(this.formData.specialPatient.cpf.value)
        : null
      const email = this.formData.specialPatient.email.value
      const gender = this.formData.specialPatient.gender.value
      const nationalHealthCard = this.formData.specialPatient.nationalHealthCard.value
      const rg = this.formData.specialPatient.rg.value

      // Address
      const cep = (this.formData.address.cep.value)
        ? this.fn_NUMBERS_ONLY(this.formData.address.cep.value)
        : null
      const city = { name: this.formData.address.city.value }
      const uf = this.formData.address.uf.value
      const district = this.formData.address.district.value
      const street = this.formData.address.street.value
      const number = this.formData.address.number.value
      const latitude = this.formData.address.latitude.value
      const longitude = this.formData.address.longitude.value
      const complement = (this.formData.address.complement.value)
        ? this.formData.address.complement.value
        : null

      // Financial statement
      const date = this.$moment(this.formData.receiptDate.value, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
      const value = this.formData.value.value.raw
      const isConsolidated = (this.formData.paymentStatus.value) ? 1 : 0
      const paymentMethod = this.formData.paymentMethod.options
        .find((method) => method.id === this.formData.paymentMethod.value)
      const financialStatements = [{ date, value, isConsolidated }]
      if (paymentMethod) financialStatements[0]['paymentMethod'] = paymentMethod.value

      // Build final object
      const address = (cep)
        ? { cep, city, uf, district, street, number, complement, latitude, longitude }
        : null

      // Build specialPatient
      const specialPatient = {
        name,
        ddiContactPhone,
        contactPhone,
        cpf,
        dateOfBirth,
        email,
        gender,
        nationalHealthCard,
        rg
      }

      // Add address to specialPatient
      if (address) specialPatient['address'] = address

      // hasMedicalConsultationReturn
      const hasMedicalConsultationReturn = this.formData.hasMedicalConsultationReturn.value ? 1 : 0

      // Add keys to agenda
      const agenda = {
        appointmentStart,
        appointmentFinish,
        medicalConsultationType,
        type,
        specialPatient,
        financialStatements,
        value,
        hasMedicalConsultationReturn
      }

      // Add Recommendation to specialPatient
      if (this.formData.referral.value) {
        agenda['recommendation'] = { name: this.formData.referral.value }
      }

      // Add Medical note
      if (this.formData.note.value) {
        agenda['medicalNotes'] = [{ note: this.formData.note.value }]
      }

      if (this.specialPatientId) agenda['specialPatientId'] = this.specialPatientId

      // Add healthPlan to agenda
      if (type === 'CONVENIO') {
        if (this.isHealthPlanSaved) {
          agenda['specialPatientHealthInsuranceId'] = this.formData.specialPatientHealthInsurance.healthInsurance.value
        } else {
          const {
            healthInsurance,
            walletNumber,
            walletValidity
          } = this.formData.specialPatientHealthInsurance

          agenda['specialPatientHealthInsurance'] = {
            healthInsurance: healthInsurance.value,
            walletNumber: walletNumber.value,
            walletValidity: this.$moment(walletValidity.value, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
          }
        }
      }

      // Add medicalConsultationType to agenda
      if (/(exame|procedimento)/gi.test(medicalConsultationType)) {
        agenda['doctorOfficeMedicalService'] = this.formData.doctorOfficeMedicalService.value
      }

      return agenda
    },

    destroyApiObject (object) {
      const recursiveNullify = (obj) => {
        for (const key in obj) {
          if ('value' in obj[key]) {
            obj[key].value = null
          } else {
            recursiveNullify(obj[key])
          }
        }
      }

      recursiveNullify(object)

      object.value = {
        mask: '####',
        type: 'currency',
        name: 'value',
        placeholder: 'Valor',
        value: {
          converted: null,
          raw: 0
        }
      }
    },

    loadAppointmentData (loader, into) {
      const findId = (where, what) => where.find(w => w.value === what).id

      const getPatientsHealthInsurance = (id) => {
        let data = null
        const url = `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${this.office.id}/special_patient/${id}/special_patient_health_insurance`
        this.$http.get(url, this.$store.getters.getAuthHeader)
          .then(res => (this.$set(this.patientObject, 'special_patient_health_insurances', res.data)))
          .catch(err => console.log('err', err))

        return data
      }

      const patient = loader.user.id ? loader.user : loader.patient

      this.appointmentStatus = loader.status
      this.$set(into.id, 'value', loader.id)

      into.appointmentStart.value = this.$moment(loader['appointment_start']).toISOString()
      into.appointmentFinish.value = this.$moment(loader['appointment_finish']).toISOString()

      // Se método de pagamento igual a HEALTHPLACE PRE PAGO
      // mostra essa opção no formulário
      if (
        loader['financial_statement']['payment_method'] === 'HEALTHPLACE PRÉ PAGO' ||
        loader['financial_statement']['payment_method'] === 'HEALTHPLACE PRÉ PAGO VOUCHER'
      ) {
        into.paymentMethod.options.forEach(o => (o.hidden = false))
      }

      into.paymentMethod.value = loader['financial_statement']['payment_method']
        ? findId(into.paymentMethod.options, loader['financial_statement']['payment_method'])
        : null
      into.paymentStatus.value = (loader['financial_statement']['is_consolidated']) ? 1 : 0
      into.receiptDate.value = this.$moment(loader['financial_statement'].date).format('DD/MM/YYYY')

      // into.value.value.raw = loader['financial_statement'].value || 0
      // into.value.value.converted = String(loader['financial_statement'].value || 0).replace('.', ',')
      let value = 0

      if (loader.agenda_payment.doctor_price) {
        value = loader.agenda_payment.doctor_price
      } else if (loader.value) {
        value = loader.value
      } else if (loader['financial_statement'].value) {
        value = loader['financial_statement'].value
      }

      into.value.value.raw = value
      into.value.value.converted = String(value).replace('.', ',')

      into.schedulingType.value = loader['medical_consultation_type']
      into.appointmentType.value = /telemedicina|telemedicine/gi.test(loader.type)
        ? 'PARTICULAR_TELEMEDICINA'
        : loader['type']

      if (/healthplace|drconecta/gi.test(loader.type)) {
        this.showHealthplaceInfo = true

        this.healthPlaceInfoMsg.radios[0].label = /telemedicina|telemedicine/gi.test(loader.type)
          ? 'Consulta telemedicina'
          : 'Consulta presencial'
      }

      this.$nextTick(() => {
        this.$refs.referral.$el.children[0].children[0].children[0].children[0].children[0].value = loader['recommendation'].name
        this.$refs.referral.searchTerm = ''
      })

      into.referral.value = loader['recommendation'].name
      into.note.value = loader['medical_note'].note

      into.hasMedicalConsultationReturn.value = loader['has_medical_consultation_return']

      into.doctorOfficeMedicalService.value = /(exame|procedimento)/gi.test(into.schedulingType.value)
        ? loader['doctor_office_medical_service'].id
        : null
      this.patientObject = { ...patient }
      this.specialPatientId = patient['id']
      this.patientName = patient['name']

      this.$refs['autocomplete_patientName'].$el.childNodes[0].childNodes[0].value = patient['name']

      // Set saved health plan
      const healthInsurancePlan = loader['special_patient_health_insurance'] || null
      if (healthInsurancePlan) this.$refs['appointmentHealthInsurance'].choosePlan(healthInsurancePlan)

      if (!/(drconecta)/gi.test(into.appointmentType.value)) {
        getPatientsHealthInsurance(patient['id'])
      }

      this.appointmentFull = true
    },

    setHealthPlan (plan) {
      const { id, walletNumber, walletValidity, isSaved } = plan
      this.formData.specialPatientHealthInsurance.healthInsurance.value = id
      this.formData.specialPatientHealthInsurance.walletNumber.value = walletNumber
      this.formData.specialPatientHealthInsurance.walletValidity.value = walletValidity
      this.isHealthPlanSaved = isSaved
    },

    setDoctorOfficeMedicalService (service) {
      if (service) {
        this.formData.value.value.raw = service.price
        this.formData.value.value.converted = this.$options.filters.TO_BRL(service.price)
        this.formData.doctorOfficeMedicalService.value = service.id
      }
    },

    searchAddress (cep) {
      if (this.shouldValidateCep) {
        this.$http
          .get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`)
          .then((res) => {
            if (res.data) {
              const { data } = res
              const setDisable = (object, property, value) => {
                property.forEach(p => (object[p].disabled = value))
              }

              setDisable(
                this.formData.address,
                ['street', 'district', 'city', 'uf', 'street'],
                true
              )
              // se encontrou o CEP, mas sem rua e bairro, habilita estes campos para edição
              if (!data.logradouro || !data.bairro || (data.logradouro.length + data.bairro.length) === 0) {
                setDisable(
                  this.formData.address,
                  ['district', 'street'],
                  false
                )
              }

              const self = this

              this.formData.address.street.value = this.formData.address.street.value && !data.logradouro ? this.formData.address.street.value : data.logradouro
              this.formData.address.district.value = this.formData.address.district.value && !data.bairro ? this.formData.address.district.value : data.bairro
              this.formData.address.city.value = data.localidade
              this.formData.address.uf.value = data.uf

              if ('erro' in data) {
                this.$store.dispatch('setModalConfirm', {
                  title: 'CEP não encontrado',
                  body: 'Deseja pesquisar um outro CEP ou editar o endereço manualmente?',
                  confirmText: 'Editar',
                  cancelText: 'Pesquisar',
                  beforeClose: (v) => {
                    if (v) {
                      setDisable(
                        this.formData.address,
                        ['street', 'district', 'city', 'uf'],
                        false
                      )
                    }
                    this.$store.dispatch('setModalConfirm')
                  },
                  size: 'md',
                  active: true
                })
              } else {
                const key = this.$store.getters.$_getMapsApi
                const address = `${this.formData.address.street.value},
                  ${this.formData.address.number.value},
                  ${this.formData.address.district.value},
                  ${this.formData.address.city.value} -
                  ${this.formData.address.uf.value}`

                this.$http
                  .get(`https://maps.google.com/maps/api/geocode/json?key=${key}&address=${address}`)
                  .then((res) => {
                    if (res.status === 200) {
                      const { data } = res
                      if (data.results.length > 0) {
                        const { geometry } = data.results[0]
                        this.formData.address.latitude.value = geometry.location.lat
                        this.formData.address.longitude.value = geometry.location.lng
                      }
                    }
                  })
                  .catch((err) => {
                    console.log('err', err)
                  })
              }
            }
          })
          .catch((err) => {
            console.log('err', err)
          })
      }

      this.shouldValidateCep = true
    },

    setAppointmentEnd () {
      const startDate = this.$moment(this.appointmentStartDate)
      const endDate = this.$moment(this.appointmentEndDate)

      const then = this.$moment()
        .hours(this.appointmentStartHour)
        .minutes(this.appointmentStartMin)
        .add(this.appointmentInterval, 'minutes')

      if (startDate.isSame(endDate, 'day')) {
        this.appointmentEndHourFrom = this.appointmentStartHour
        this.appointmentEndHour = this.$moment(then).hours()
        this.appointmentEndMin = Math.ceil(this.$moment(then).minutes() / 5) * 5
      } else {
        this.appointmentEndHourFrom = 0
        this.appointmentEndHour = this.$moment(then).hours()
        this.appointmentEndMin = Math.ceil(this.$moment(then).minutes() / 5) * 5
      }
    },

    setAppointmentDate () {
      const now = this.$moment(this.now).format('YYYY-MM-DD')
      const startMin = String(this.appointmentStartMin).padStart(2, '0')
      const endMin = String(this.appointmentEndMin).padStart(2, '0')
      const startTime = `${this.appointmentStartHour}:${startMin}:00`
      const endTime = `${this.appointmentEndHour}:${endMin}:00`
      const start = `${now} ${startTime}`
      const end = `${now} ${endTime}`

      this.formData.appointmentStart.value = start
      this.formData.appointmentFinish.value = end
    },

    setPaymentStatus (check) {
      this.formData.paymentStatus.value = check
    },

    autoResizeTextarea () {
      const textarea = document.querySelector('#appointment-simple_note')

      textarea.addEventListener('input', (el) => {
        const field = el.target
        const computed = window.getComputedStyle(field)

        field.style.height = 'inherit'

        const height = parseInt(computed.getPropertyValue('border-top-width'), 10) +
          parseInt(computed.getPropertyValue('padding-top'), 10) +
          field.scrollHeight +
          parseInt(computed.getPropertyValue('padding-bottom'), 10) +
          parseInt(computed.getPropertyValue('border-bottom-width'), 10)

        field.style.height = `calc(${height}px - 0.9rem)`
      })
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    },

    startAppointment () {
      if (this.shouldBlockStartAppointment) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Atenção',
          body: `Antes de iniciar essa consulta, você precisa validar seu certificado
            de assinatura digital. Isso é importante para que o paciente possa utilizar
            os documentos gerados por você nesta consulta.`,
          confirmText: 'Certificado digital',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.$router.push({ name: 'DoctorUserCertificates' })
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })
        return
      }

      const agendaId = this.formData.id.value
      this.$router.push({
        name: 'DoctorAppointmentsDetails',
        params: {
          id: this.specialPatientId,
          agendaId: agendaId,
          patientType: /(drconecta|healthplace)/gi.test(this.appointment.type)
            ? 'patient'
            : 'specialPatient'
        }
      })
      this.$store.dispatch('setAppointmentStart', true)
    },

    cancelAppointment () {
      if (
        /healthplace/gi.test(this.appointment.type) &&
        /boleto/gi.test(this.appointment['agenda_payment']['payment_method'])
      ) {
        this.$store.dispatch(
          'setModalAlert',
          {
            title: 'Alerta',
            body: `Essa consulta foi paga pelo paciente através de boleto bancário e
              não possibilita o estorno do valor. Dessa forma, entre em contato com
              o time de suporte, via chat, para providenciar alteração de data/horário
              do atendimento.`,
            size: 'md',
            active: true
          }
        )

        return
      }

      const id = this.formData.id.value
      const officeId = this.appointment['doctor_office'].id
      const url = `/${
        this.fn_GET_PARENT_ROUTE(this.$route)
      }/doctor_office/${officeId}/agenda/${id}`

      this.$store.dispatch(
        'setModalConfirm',
        {
          title: 'Confirmação',
          body: `Tem certeza que deseja cancelar a consulta?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (!v) {
              this.$store.dispatch('setModalConfirm')
            } else {
              this.fn_SHOW_PROGRESS()
              this.$http
                .delete(url, this.$store.getters.getAuthHeader)
                .then((res) => {
                  this.$store.dispatch('setModalConfirm')

                  let msg = 'Consulta cancelada com sucesso'

                  if (/healthplace/gi.test(this.appointment.type)) {
                    msg = `Consulta cancelada com sucesso.<br>
                      Por favor, mantenha seus horários atualizados e,
                      se necessário, bloqueie sua agenda quando não tiver
                      disponibilidade para o atendimento. Isso evitará
                      transtornos com o paciente e eventual suspensão
                      de sua conta no Market Place.`
                  }

                  this.$store.dispatch('setModalAlert', {
                    title: 'Sucesso',
                    body: msg,
                    size: 'md',
                    active: true
                  })

                  EventBus.$emit('agenda-reload', { officeId: this.office.id })
                })
                .catch((err) => {
                  this.$store.dispatch('setModalConfirm')
                  this.handleError(err)
                })
                .finally(() => {
                  this.fn_HIDE_PROGRESS()
                  this.close()
                })
            }
          },
          size: 'md',
          active: true
        }
      )
    },

    notifyAbsence () {
      this.$store.dispatch(
        'setModalConfirm',
        {
          title: 'Confirmação',
          body: `Tem certeza que deseja confirmar a ausência do paciente?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (!v) {
              this.$store.dispatch('setModalConfirm')
            } else {
              const id = this.formData.id.value
              const officeId = this.appointment['doctor_office'].id
              const url = `/${
                this.fn_GET_PARENT_ROUTE(this.$route)
              }/doctor_office/${officeId}/agenda/${id}/absent`
              const method = 'put'
              const headers = this.$store.getters.getAuthHeader.headers

              this.fn_SHOW_PROGRESS()
              this.$http({ url, method, headers })
                .then((res) => {
                  this.$store.dispatch('setModalConfirm')

                  this.$store.dispatch('setModalAlert', {
                    title: 'Sucesso',
                    body: 'Ausência informada com sucesso.',
                    size: 'md',
                    active: true
                  })
                })
                .catch((err) => {
                  this.$store.dispatch('setModalConfirm')
                  this.handleError(err)
                })
                .finally(() => {
                  EventBus.$emit('agenda-reload', { officeId: this.office.id })
                  this.fn_HIDE_PROGRESS()
                  this.close()
                })
            }
          },
          size: 'md',
          active: true
        }
      )
    },

    showAppIntegrationAlert () {
      if (this.appIntegration && !this.appIntegration['is_active']) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Aviso',
          body: `Para usufruir dessa funcionalidade, você
            precisa estar integrado ao app Dr. Conecta e
            ter sua página de perfil público. Dessa forma,
            teremos acesso ao seu intervalo de atendimento
            e poderemos assim disponibilizar seus horários
            ao paciente.`,
          confirmText: 'Integrar com o app Dr. Conecta',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.$router.push({ name: 'DoctorAppIntegration' })
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md2',
          active: true
        })
      }
    },

    close () {
      this.$emit('cancel', true)
    },

    handleModalityClick (event) {
      if (this.plan.isPro) {
        event.preventDefault()
        this.$store.dispatch('togglePlanModal', { showModal: false })
      }
    }
  }
}
</script>
